import { StateContext } from '@ngxs/store';
import { patch, updateItem } from '@ngxs/store/operators';
import { Page } from 'src/modules/shared/model/page';
import { ExhibitionStateModel } from '../exhibition.state';
import { ChangePageRowNumber } from '../exhibition.state.actions';

export const changePageRowNumber = (ctx: StateContext<ExhibitionStateModel>, action: ChangePageRowNumber) => {
    const state = ctx.getState();
    ctx.setState(
        patch({
            pages: updateItem<Page>(
                (item) => item?.page_number === state.selectedPage && item?.language === state.selectedLanguage,
                patch({ row_number: action.payload.rowNumber })
            )
        })
    );
};
